import React from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import AddLogButton from './AddLogButton';
import TimeLog from './TimeLog';
import WatermarkHoliday from '../../../../assets/images/watermark_holiday.svg';
import WatermarkVacation from '../../../../assets/images/watermark_vacation.svg';
import type { CalendarDate, Holiday, Log, Project } from '../../../types';

type Props = {
  day: CalendarDate,
  logsById: { [k: string]: Log },
  logIds: Array<string | number>,
  onOpenAddModal: (date: string) => void,
  onOpenEditModal: (log: Log, date: string) => void,
  dayNamesByDate: { [k: string]: string },
  projects: Array<Project>,
  showTab: boolean,
  holidays: Array<Holiday>,
  selectedUserVacationDates: Array<string>,
}

const DayColumnSmall = (props: Props) => {
  const {
    day, logsById, logIds, showTab,
    onOpenAddModal, onOpenEditModal, dayNamesByDate,
    projects, holidays, selectedUserVacationDates,
  } = props;
  const dailyTotal = _.sum(logIds.map(logId => _.toNumber(logsById[logId].time_spent)));
  const isHoliday = holidays.filter(holiday => holiday.date === day.date).length > 0;
  const isVacation = selectedUserVacationDates.filter(vacation => vacation === day.date).length > 0;
  const isWorkday = day.dayName !== 'Sat' && day.dayName !== 'Sun' && !isHoliday && !isVacation;
  const hoursMissing = dailyTotal < 8;
  let classes = 'tab-pane col-12 mt-3 text-center';
  if (showTab) {
    classes += ' fade show active';
  }

  const dailyTotalParsed = parseFloat(dailyTotal).toFixed(2);

  return (
    <div role="tabpanel" className={classes} id={dayNamesByDate[day.date]} data-date={day.date}>
      <div className="container-fluid day-column">
        <div className={`total-hours text-center ${isWorkday && hoursMissing ? 'hours-missing' : ''}`}>
          <h5>{`Total ${dailyTotal.toString().length >= 4 ? dailyTotalParsed : dailyTotal}h`}</h5>
        </div>
        <div className={classNames("billable", { 'holiday': isHoliday, 'vacation': isVacation })}>
          {isHoliday && (<img className="watermark" src={WatermarkHoliday} alt="holiday" />)}
          {isVacation && (<img className="watermark" src={WatermarkVacation} alt="vacation" />)}
          {logIds.map(logId => (
            <div key={logId}>
              {logsById[logId].project_billable && (
                <TimeLog
                  day={day}
                  onOpenEditModal={onOpenEditModal}
                  projects={projects}
                  log={logsById[logId]}
                  key={logId}
                />
              )}
            </div>
          ))}
        </div>
        <div className="non-billable">
          {logIds.map(logId => (
            <div key={logId}>
              {logsById[logId].project_billable === false && (
                <TimeLog
                  day={day}
                  onOpenEditModal={onOpenEditModal}
                  projects={projects}
                  log={logsById[logId]}
                  key={logId}
                />
              )}
            </div>
          ))}
        </div>
        <AddLogButton onOpenAddModal={onOpenAddModal} id={day.date} small />
      </div>
    </div>
  );
};

export default DayColumnSmall;
